// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".call-to-action-blocks[data-v-590901e5]{display:grid;grid-template-columns:repeat(1,minmax(0,1fr));justify-items:stretch;grid-gap:1rem;gap:1rem}@media (min-width:48em){.call-to-action-blocks[data-v-590901e5]{grid-template-columns:repeat(2,minmax(0,1fr))}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
